import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface MswProductClaimsState {
}

export default {
  state : {},
  actions: {
    getClaimsReport(context: ActionContext<MswProductClaimsState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const url = 'claims/SubscriptionReport-Claims?isforced=true';
      return ApiServiceWrapper.get(url);
    },
  },
  namespaced: true,
} as Module<MswProductClaimsState, RootStoreState>;
